import Order from '@/shared/types/order/order.type';
import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

const getOrders = async (customerId: string, onUnauthorized?: () => void) => {
  const token = getCookie('auth_token');

  try {
    return await fetcher<Response<Order[]>>({
      url: `/orders/view/`,
      method: 'POST',
      token,
      body: {
        search: [
          {
            in_customer_id: {
              cop: ['='],
              value: customerId,
            },
          },
        ],
        sort_order: 'asc',
        page_size: 3,
      },
      onUnauthorized,
    });
  } catch (error) {
    console.error(
      'Error occurred in function "getOrders" in file "src/shared/api/customer/getOrders.ts":',
      error,
    );
    return error as Response<Order[]>;
  }
};

export default getOrders;
